import React from 'react';
import './LowboyTimesheet.scss';
import { Card, CardBody, FormGroup, Input } from 'reactstrap';
import { FormLabel } from '../common/forms/FormElements';

export default class LowboyTimesheetNotesCard extends React.Component {
    onNotesChange = (e) => {
        const notes = e && e.target ? e.target.value : null;

        const { lowboyTimesheet, onTimesheetMutated } = this.props;

        lowboyTimesheet.notes = notes;

        onTimesheetMutated(lowboyTimesheet);
    };

    onAdjustmentNotesChange = (e) => {
        const adjustmentNotes = e && e.target ? e.target.value : null;

        const { lowboyTimesheet, onTimesheetMutated } = this.props;

        lowboyTimesheet.adjustmentNotes = adjustmentNotes;

        onTimesheetMutated(lowboyTimesheet);
    };

    render() {
        const { loading, isReadOnly, isAdmin, lowboyTimesheet } = this.props;

        if (loading || !lowboyTimesheet) {
            return null;
        }

        return (
            <Card className="mt-1">
                <CardBody>
                    <FormGroup>
                        <FormLabel text="Notes" />
                        <Input
                            type="textarea"
                            value={lowboyTimesheet.notes || ''}
                            readOnly={isReadOnly || isAdmin}
                            onChange={this.onNotesChange}
                        />
                    </FormGroup>

                    {isAdmin && (
                        <FormGroup>
                            <FormLabel text="Adjustment Notes" />
                            <Input
                                type="textarea"
                                value={lowboyTimesheet.adjustmentNotes || ''}
                                readOnly={isReadOnly}
                                onChange={this.onAdjustmentNotesChange}
                            />
                        </FormGroup>
                    )}
                </CardBody>
            </Card>
        );
    }
}
